import { InfoOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import { getLocalTranslation } from '../../../utils/i18nKit';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var JoveNoQuoteCoverageOptionsAlertInfoView = function JoveNoQuoteCoverageOptionsAlertInfoView(props) {
  var className = props.className;

  var _getLocalTranslation = getLocalTranslation(),
      $t = _getLocalTranslation.$t;

  return /*#__PURE__*/_jsxs(Box, {
    className: clsx('flex flex-row items-center space-x-1 rounded-lg bg-[#F9DEDC] p-2', className),
    children: [/*#__PURE__*/_jsx(InfoOutlined, {
      className: "h-4 w-4 text-[#d32f2f]"
    }), /*#__PURE__*/_jsxs(Typography, {
      variant: "subtitle2",
      className: "font-bold text-[#DD1F1F]",
      children: [$t('kit:quotes.coverage_information_is_temporarily_unavailable'), "."]
    })]
  });
};